import React from 'react';
import ScellantHero from './ScellantHero';
import ScellantBeforeAfter from './ScellantBeforeAfter';
import ScellantServices from './ScellantServices';
import QuiNousSommes from './QuiNousSommes';
import ScellantGallery from './ScellantGallery';
import ScellantTestimonials from './ScellantTestimonials';
import ScellantContact from './ScellantContact';
import Footer from './Footer';
import { Toaster } from './ui/sonner';

const ScellantPage = () => {
  return (
    <>
      <main>
        <ScellantHero />
        <ScellantBeforeAfter />
        <ScellantServices />
        <QuiNousSommes theme="dark" />
        <ScellantGallery />
        <ScellantTestimonials />
        <ScellantContact />
      </main>
      <Footer />
      <Toaster />
    </>
  );
};

export default ScellantPage;
